import { action } from 'satcheljs';

/**
 * Action to enable/disable an availability profile from the store.
 */
let enableDisableProfile = action(
    'ENABLE_DISABLE_AVAILABILITY_PROFILE',
    (serviceId: string, enable: boolean) => ({
        serviceId,
        enable,
    })
);

export default enableDisableProfile;
